"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountDefinitionList = exports.createAccountDefinitionList = void 0;
var tslib_1 = require("tslib");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
function createAccountDefinitionList(account) {
    var fein = account.fein, identities = account.identities, primaryContact = account.primaryContact, mailingAddress = account.mailingAddress;
    var items = [];
    if (fein) {
        items.push({
            type: 'number',
            title: 'FEIN',
            value: fein,
        });
    }
    if (identities) {
        identities.forEach(function (identity) {
            if (identity && identity.value) {
                var title = identity.title, value = identity.value;
                items.push({
                    type: 'number',
                    title: title || 'Identifier',
                    value: value,
                });
            }
        });
    }
    if (primaryContact) {
        items.push({
            type: 'contact',
            title: 'Primary contact',
            value: primaryContact.name,
            subValue: primaryContact.email,
        });
    }
    if (mailingAddress) {
        items.push({
            type: 'location',
            title: 'Mailing address',
            value: mailingAddress.firstLine,
            subValue: mailingAddress.secondLine,
        });
    }
    return items;
}
exports.createAccountDefinitionList = createAccountDefinitionList;
function AccountDefinitionList(props) {
    var accountDefinition = props.accountDefinition, hideTitle = props.hideTitle;
    return (react_1.default.createElement(definition_list_1.DefinitionList, { hideTitle: hideTitle, items: createAccountDefinitionList(accountDefinition), labelWidth: "150px" }));
}
exports.AccountDefinitionList = AccountDefinitionList;
//# sourceMappingURL=index.js.map